import React from "react";
import Box from "@material-ui/core/Box";
import { Skeleton } from "@material-ui/lab";
import { BusinessOwnerLayout } from "frontend/src/pages/layouts";
import { PaperTabLayout } from "frontend/src/ui/paper-tab-layout";
import { SearchCatalog } from "frontend/src/domain/tracks";
import { ViewerAddableAudioAdvertisements } from "frontend/src/domain/audio-advertisements";
import { DataTableSkeleton } from "frontend/src/ui/data-table-skeleton";
import { TabsSkeleton } from "frontend/src/ui/tabs-skeleton";
import { Playlist } from "./playlist";
import { useViewerAddableAudioAdvertisementList, usePagePlaylist, usePlaylist, } from "./model";
var Page = function (_a) {
    var playlist = _a.playlist;
    var _b = usePlaylist(playlist), title = _b.title, entries = _b.entries, actions = _b.actions;
    var advertisementList = useViewerAddableAudioAdvertisementList({
        tracks: {
            countMap: entries.tracks.countMap,
            add: entries.add,
            remove: entries.remove.byIdLast,
        },
    });
    var tabs = [
        {
            label: "Плейлист",
            node: (React.createElement(Playlist, { title: title, entries: {
                    value: entries.value,
                    remove: entries.remove.byIndex,
                    reorder: entries.reorder,
                    tracks: entries.tracks.all,
                }, handlers: {
                    submit: {
                        do: actions.update.do,
                        pending: actions.update.pending,
                    },
                    play: actions.play,
                    pause: actions.pause,
                } })),
        },
        {
            label: "Каталог треков",
            node: (React.createElement(SearchCatalog, { onTrackAdd: entries.add, onTracksAdd: entries.addMany, onTrackRemove: entries.remove.byIdLast, addedTrackCounter: entries.tracks.countMap, showPlaylistImport: false, showAdminColumns: false, showIsrcToggle: false })),
        },
        {
            label: "Загруженные файлы",
            node: advertisementList.items ? (React.createElement(ViewerAddableAudioAdvertisements, { tracks: {
                    empty: advertisementList.empty,
                    items: advertisementList.items,
                } })) : (React.createElement(React.Fragment, null)),
        },
    ];
    return React.createElement(PaperTabLayout, { tabs: tabs, keepMounted: true });
};
export var EditPlaylistPage = function () {
    var playlist = usePagePlaylist().playlist;
    return (React.createElement(BusinessOwnerLayout, null, playlist ? (React.createElement(Page, { playlist: playlist })) : (React.createElement(TabsSkeleton, null,
        React.createElement(Skeleton, { variant: "rect", height: 124 }),
        React.createElement(Box, { mt: 1 },
            React.createElement(DataTableSkeleton, null))))));
};
